import React, { useState, useRef, useEffect } from "react";
import { Box, TextField, Paper, MenuItem } from "@mui/material";
const days = [
  { guid: "mon", name: "Monday" },
  { guid: "tue", name: "Tuesday" },
  { guid: "wed", name: "Wednesday" },
  { guid: "thu", name: "Thursday" },
  { guid: "fri", name: "Friday" },
  { guid: "sat", name: "Saturday" },
];

const DropDownField = ({ label, value, onChange,disabled, options = [], error }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // ✅ CLOSE ON OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Box ref={wrapperRef} sx={{ position: "relative",mb:2 }}>
      <TextField
        label={label}
        value={options.find((o) => o.guid === value)?.name || ""}
        fullWidth
              disabled={disabled}          // 👈 this is the important line

        error={error}
        InputProps={{
          sx: { borderRadius: 3, cursor: "pointer" },
          readOnly: true,
        }}
        onClick={(e) => {
          e.stopPropagation(); // 🔥 IMPORTANT
          setOpen((prev) => !prev);
        }}
      />

      {open && (
        <Paper
          elevation={6}
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 7000, // higher than panel
            maxHeight: 250,
            overflowY: "auto",
            borderRadius: 2,
            mt: 0.5,
          }}
        >
          {options.map((item) => (
            <MenuItem
              key={item.guid}
              disabled={item.disabled}
              onClick={() => {
                if (!item.disabled) {
                  onChange(item.guid);
                  setOpen(false); // ✅ close after select
                }
              }}
              sx={item.disabled ? { color: "text.disabled", bgcolor: "action.disabledBackground" } : {}}
            >
              {item.name}
            </MenuItem>
          ))}
        </Paper>
      )}
    </Box>
  );
};

export default DropDownField;
